import { FC, ReactElement, useLayoutEffect } from "react";
import svg from "../../assets/img/sprite.svg";
import "./Modal.scss";

interface ModalProps {
  active: boolean;
  setActive: (value: boolean) => void;
  children: ReactElement;
}

export const Modal: FC<ModalProps> = ({ active, setActive, children }) => {

  useLayoutEffect(() => {
    if (active) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }

    return () => {
      document.body.style.overflow = "visible";
    };
  }, [active]);  

  return (
    <div
      className={active ? "modal active" : "modal"}
      onMouseDown={() => setActive(false)}
    >
      <div
        onMouseDown={(e) => e.stopPropagation()}
        className={active ? "modal__content active" : "modal__content"}
      >
        <button className="modal__close" onMouseDown={() => setActive(false)}>
          <svg width="30" height="30">
            <use xlinkHref={`${svg}#x`}></use>
          </svg>
        </button>
        {children}
      </div>
    </div>
  );
};
